// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function () {
  var mySwiper = new Swiper('.swiper-home-slider', {
    // Swiper options here
    autoplay: {
      delay: 5000,
    },
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  var swiperServizi = new Swiper('.swiper-slider-servizi', {
    // Swiper options here
    loop: true,
    slidesPerView: 2,
    spaceBetween: 15,
    pagination: {
      el: '.slider__pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // Responsive breakpoints
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 40,
      }
    }
  });
});

jQuery(document).ready(function ($) {
  $(".hamburger").click(function () {
      $("body").toggleClass("noScroll");
      $(this).toggleClass("active");
      $('.offcanvas-menu').toggleClass("active");
      // $('.site-header').toggleClass("offcanvas-active");
      // setTimeout(function(){
      //     $('.offcanvas-nav-container').toggleClass("active");
      // },800);
      // also open menu here...
  });
});
